import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
    selector: '[sectionAnchor]',
    standalone: false
})
export class SectionAnchorDirective {
  public viewContainerRef = inject(ViewContainerRef);
}
